import React, { useState, useEffect, useMemo } from 'react';  
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';  
import styled, { keyframes, createGlobalStyle } from 'styled-components';  
import SelectFarm from './pages/01_Select_Farm';  
import AddNewFarm from './pages/03_AddNewFarm';  
import SelectMachine from './pages/11_Select_Machine';  
import RobotInfo from './pages/12_Detail_Robot_Info';  
import NewHarvestImagePage from './pages/123_NewHarvestImage';  
import ImageDisplay from './pages/121_RealTImeImageDisplay';  
import NewtelemetryPage from './pages/122_Newtelemetry';  
import AllRoboDailyTotalTelemetry from './pages/140_AllRoboDailyTotalTelemetry';  
import HarvestAnalytics from './pages/HarvestAnalytics';  
// import Settings from './pages/Settings';  
import Database from './pages/300_database'; 
import QrCode from './pages/150_Share_QrCode';  
import Ai from './pages/999_Ai';  // 新しいページをインポート
import TabNavigation from './pages/TabNavigation';  
import FarmsData from './pages/02_Detail_farm_info';  
import SplashScreen from './components/SplashScreen';  
import MarketData from './pages/200_MarketData';  
import ChartPage from './pages/04_SensingChartDetail'; // 新しいチャートページをインポート 
  
const GlobalStyle = createGlobalStyle`  
  * {  
    user-select: none;  // 全体の要素に対して選択を無効化  
  }  
`;  
  
// フェードインアニメーションを定義  
const fadeIn = keyframes`  
  from {  
    opacity: 0;  
    transform: translateY(20px);  // 少し下からスライド  
  }  
  to {  
    opacity: 1;  
    transform: translateY(0);  
  }  
`;  
  
// コンテンツのフェードイン効果用のコンテナ  
const PageContainer = styled.div`  
  opacity: 0;  // 初期状態は透明  
  animation: ${fadeIn} 1s ease-in-out forwards;  // フェードインアニメーションを適用  
  display: flex;  
  flex-direction: column;  
  min-height: 100vh;  
  padding-bottom: 60px;  
  width: 100%;  
  box-sizing: border-box;  
  overflow-y: auto;  
`;  
  
const ScrollToTop = () => {  
  const { pathname } = useLocation();  
  
  useEffect(() => {  
    window.scrollTo(0, 0);  
  }, [pathname]);  
  
  return null;  
};  
  
function App() {  
  const [loading, setLoading] = useState(true);  
  const location = useLocation();  
  
  // skipSplashPathsをuseMemoでラップ  
  const skipSplashPaths = useMemo(() => ['/video-feed', '/latest-images', '/new-data'], []);  
  
  // 初回ロード時のスプラッシュ画面表示  
  useEffect(() => {  
    if (skipSplashPaths.some(path => location.pathname.includes(path))) {  
      setLoading(false);  
    } else {  
      const timer = setTimeout(() => {  
        setLoading(false);  // 3秒後にコンテンツを表示  
      }, 3000);  
  
      return () => clearTimeout(timer);  // クリーンアップタイマー  
    }  
  }, [location.pathname, skipSplashPaths]);  
  
  // ナビゲーションバークリック時のスプラッシュ画面表示  
  const handleNavClick = () => {  
    if (!skipSplashPaths.some(path => location.pathname.includes(path))) {  
      setLoading(true);  // スプラッシュを表示開始  
  
      setTimeout(() => {  
        setLoading(false);  // 3秒後にスプラッシュを非表示  
      }, 3000);  // スプラッシュ画面を3秒間表示  
    }  
  };  
  
  return (  
    <>  
      <GlobalStyle />  
      {loading ? (  
        <SplashScreen />  // スプラッシュ画面を表示  
      ) : (  
        <>  
          <PageContainer>  
            <ScrollToTop />  
            <Routes>  
              <Route path="/" element={<SelectFarm />} />  
              <Route path="/farm" element={<SelectFarm />} />  
              <Route path="/chart" element={<ChartPage />} /> {/* 新しいチャートページのルート */}  
              <Route path="/add-new-farm" element={<AddNewFarm />} />  {/* 新しいルートを追加 */}  
              <Route path="/robots" element={<SelectMachine />} />  
              <Route path="/:id" element={<RobotInfo />} />  
              <Route path="/:id/new-data" element={<NewtelemetryPage />} />    
              <Route path="/:id/latest-images" element={<NewHarvestImagePage />} />  
              <Route path="/:id/video-feed" element={<ImageDisplay />} />  
              <Route path="/telemetry/" element={<AllRoboDailyTotalTelemetry />} />  
              <Route path="/farm/:greenhouse" element={<FarmsData />} />  
              <Route path="/analytics" element={<HarvestAnalytics />} />  
              {/* <Route path="/settings" element={<Settings />} />   */}
              <Route path="/data-base" element={<Database />} /> 
              <Route path="/market-data" element={<MarketData />} /> {/* 追加 */}  
              <Route path="/Ai" element={<Ai />} />  
              <Route path="/qrcode" element={<QrCode />} />  
            </Routes>  
          </PageContainer>  
          <TabNavigation onNavClick={handleNavClick} />  {/* ナビゲーションバークリック時にスプラッシュ */}  
        </>  
      )}  
    </>  
  );  
}  
  
export default function RootApp() {  
  return (  
    <BrowserRouter>  
      <App />  
    </BrowserRouter>  
  );  
}  
